import { EnumPagTpTransacao } from "api/cardapio/models/finalizadora/finalizadora-model";
import { EnumPagTpMod } from "models/enums/enum-pag-tpmod";
import { useMasterApi } from "modulos/cardapio/containers/cardapio/hooks";
import { useParams } from "react-router-dom";

export const usePagamentos = () => {
    const { empresaId } = useParams<{ empresaId: string }>()
    const { dados: apiMasterDados } = useMasterApi(empresaId);
    const formasPagamento = apiMasterDados?.data?.finalizadoras || []


    const getFormasPagamentoNaoIntegrado = () => {
        const pagamentos = formasPagamento.filter((pagamento) =>
            pagamento.tpTransacao !== EnumPagTpTransacao.S2_PAY &&
            pagamento.tpTransacao !== EnumPagTpTransacao.SAFRA_PIX &&
            pagamento.tpTransacao !== EnumPagTpTransacao.S2PAY_PIX &&
            pagamento.tpTransacao !== EnumPagTpTransacao.SAFRAPAY_WALLET &&
            !pagamento.credenciado
        )

        return pagamentos
    }

    const getFormasPagamentoIntegrados = () => {
        const pagamentos = formasPagamento.filter((pagamento) => {
            if (pagamento.tpMod === EnumPagTpMod.CARTAO_CREDITO && pagamento.credenciado === true) return true
            if (pagamento.tpMod === EnumPagTpMod.PAGAMENTO_INSTANTANEO && pagamento.tpTransacao === EnumPagTpTransacao.SAFRA_PIX && pagamento.credenciado === true) return true
            if (pagamento.tpTransacao === EnumPagTpTransacao.S2PAY_PIX && pagamento.credenciado === true) return true
            return false
        })

        return pagamentos
    }

    return {
        getFormasPagamentoNaoIntegrado,
        getFormasPagamentoIntegrados
    }
}